<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :tooltipColumns="tooltipColumns"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <ConversionForm :formProps="formProps"> </ConversionForm>
            </template>
            <template #search="searchProps">
                <ConversionSearch :searchProps="searchProps"> </ConversionSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import ConversionForm from "./ConversionForm.vue";
import ConversionSearch from "./ConversionSearch.vue";
import { __ } from "@pages/Helper/utils.js";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
